



































import Vue, { PropType } from 'vue';
import * as api from '@/api';

export default Vue.extend({
    name: 'FilterAdvanced',
    props: {
        data: {
            type: Array as PropType<api.FilterAdvanced[]>,
            required: true,
        },
    },
    data() {
        return {
            collapsed: [] as boolean[],
            selectedData: [] as any[],
            timer: 0,
        };
    },
    watch: {
        data() {
            this.updateData();
        },
        selectedData: {
            deep: true,
            handler(selectedList) {
                // 防抖
                if (this.timer) {
                    clearTimeout(this.timer);
                }
                this.timer = setTimeout(() => {
                    const ret: any[] = [];
                    selectedList.forEach((selected) => {
                        if (!selected.listSelectValue && !selected.rangeInput) {
                            return;
                        }
                        const tmp: any = {};
                        tmp.keyword = selected.keyword;
                        if (selected.listSelectValue) {
                            tmp.listSelectValue = selected.listSelectValue;
                        } else {
                            tmp.rangeInput = {
                                isAsc: selected.rangeInput.isAsc,
                                minValue: selected.rangeInput.values[0],
                                maxValue: selected.rangeInput.values[1],
                            };
                        }
                        ret.push(tmp);
                    });
                    this.$emit('selectedData', ret);
                }, 300);
            },
        },
    },
    created() {
        this.updateData();
    },
    methods: {
        updateData() {
            this.collapsed = [];
            this.selectedData = [];
            this.data.forEach((property) => {
                this.collapsed.push(false);
                const tmp: any = {
                    keyword: property.keyword,
                };
                this.selectedData.push(tmp);
                if (property.listSelect) {
                    Vue.set(tmp, 'listSelectValue', null);
                } else if (property.rangeInput) {
                    Vue.set(tmp, 'rangeInput', {
                        values: [property.rangeInput.maxValue, property.rangeInput.minValue],
                        isAsc: null,
                    });
                }
            });
        },
        changeRangeValue() {
            (this.$refs.sliders as any[]).forEach((slider) => {
                slider.setValues();
            });
        },
        reset() {
            this.selectedData.forEach((selected, idx) => {
                if (selected.listSelectValue) {
                    selected.listSelectValue = null;
                }
                if (selected.rangeInput) {
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    selected.rangeInput.values = [this.data[idx].rangeInput!.minValue, this.data[idx].rangeInput!.maxValue];
                    selected.rangeInput.isAsc = null;
                }
            });
        },
    },
});
